import { motion } from 'framer-motion';
import React from 'react';
import { DropDownItem, NavItem } from '../../NavBar';
import classes from './DesktopSubItems.module.scss';
import { isNavItemVisible, NavVisibility } from '../../navItemVisibility';

type Props = {
  item: NavItem;
  handleNavigate: (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
    url: string,
    urlType: string
  ) => void;
  visibility: NavVisibility;
};

const DesktopSubItems = ({ item, handleNavigate, visibility }: Props) => {
  const hasPermission = (subItem: DropDownItem) =>
    isNavItemVisible(subItem, visibility);

  return (
    <motion.ul
      initial={{ y: -10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ type: 'tween' }}
      className={classes['item-list']}
    >
      {item.dropDownItems.map((subItem, index) => {
        return (
          hasPermission(subItem) && (
            <li
              key={index}
              onClick={(e) => handleNavigate(e, subItem.url, subItem.url_type)}
            >
              <a href='#0' onClick={(e) => e.preventDefault()}>
                {subItem.text}
              </a>
            </li>
          )
        );
      })}
    </motion.ul>
  );
};

export default DesktopSubItems;
